import React from "react";

function clamp(value, min, max) {
  const number = Number(value);

  if (!Number.isFinite(number)) return min;

  return Math.max(min, Math.min(max, number));
}

export default function LessonProgressBar({
  currentStep = 1,
  totalSteps = 22,
  label = "Level progress",
  className = "",
}) {
  const safeTotal = Math.max(1, Number(totalSteps) || 22);
  const safeCurrent = clamp(Number(currentStep) || 1, 1, safeTotal);
  const percent = clamp((safeCurrent / safeTotal) * 100, 0, 100);

  return (
    <div className={["w-full", className].join(" ")}>
      <div className="mb-2 flex items-center justify-between gap-3">
        <p className="text-[11px] font-bold uppercase tracking-wider text-[#FF914D]">
          {label}
        </p>

        <p className="text-[11px] font-semibold text-[#757575]">
          {safeCurrent} of {safeTotal}
        </p>
      </div>

      <div
        className="h-2 w-full overflow-hidden rounded-full bg-[#EFEFEF]"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(percent)}
      >
        <div
          className="h-full rounded-full bg-[#FF914D] transition-all duration-500 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}